import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { getDefaultPeriod, PeriodValue } from "@/shared/ui/period-picker"
import { LoyaltyAnalyticsDrilldown, LoyaltyAnalyticsFiltersState } from "./types"

const createInitialState = (): LoyaltyAnalyticsFiltersState => ({
    period: getDefaultPeriod(),
    storeIds: [],
    includeUnassignedStore: false,
    levels: [],
    includeUnknownLevel: false,
    includeReturns: false,
    page: 1,
})

const loyaltyAnalyticsSlice = createSlice({
    name: "loyaltyAnalytics",
    initialState: createInitialState(),
    reducers: {
        setPeriod(state, action: PayloadAction<PeriodValue>) {
            state.period = action.payload
            state.page = 1
        },
        setStoreIds(state, action: PayloadAction<string[]>) {
            state.storeIds = action.payload
            state.page = 1
        },
        setIncludeUnassignedStore(state, action: PayloadAction<boolean>) {
            state.includeUnassignedStore = action.payload
            state.page = 1
        },
        setLevels(state, action: PayloadAction<number[]>) {
            state.levels = action.payload
            state.page = 1
        },
        setIncludeUnknownLevel(state, action: PayloadAction<boolean>) {
            state.includeUnknownLevel = action.payload
            state.page = 1
        },
        setIncludeReturns(state, action: PayloadAction<boolean>) {
            state.includeReturns = action.payload
            state.page = 1
        },
        setPage(state, action: PayloadAction<number>) {
            state.page = action.payload
        },
        applyDrilldown(state, action: PayloadAction<LoyaltyAnalyticsDrilldown>) {
            state.period = action.payload.period
            state.levels = action.payload.levels
            state.storeIds = action.payload.storeIds ?? []
            state.includeUnassignedStore = action.payload.includeUnassignedStore ?? false
            state.includeUnknownLevel = action.payload.includeUnknownLevel ?? false
            state.includeReturns = action.payload.includeReturns ?? false
            state.page = 1
        },
        resetFilters() {
            return createInitialState()
        },
    },
})

export const {
    applyDrilldown,
    resetFilters,
    setIncludeReturns,
    setIncludeUnassignedStore,
    setIncludeUnknownLevel,
    setLevels,
    setPage,
    setPeriod,
    setStoreIds,
} = loyaltyAnalyticsSlice.actions

export default loyaltyAnalyticsSlice.reducer
